import { useQuery } from '@tanstack/react-query';
import { getLandlordTourDetails } from 'services/api/tours-api.service';
import { QueryKey } from 'common/enums/query-key';
import { EstateStatusDto } from 'common/enums/services/api/estates/estate-status-dto.enum';

export default function useTourListingStatus(tourId?: string) {
    return useQuery({
        queryKey: [QueryKey.Tours, tourId, 'listing-status'],
        queryFn: async () => {
            if (!tourId) return null;
            const tour = await getLandlordTourDetails(tourId);
            return tour?.estateStatus as EstateStatusDto | undefined;
        },
        enabled: !!tourId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}
